import activities from "@/api/activities";
import authors from "@/api/authors";
import bookings from "@/api/bookings";
import calendar from "@/api/calendar";
import categories from "@/api/categories";
import departments from "@/api/departments";
import employees from "@/api/employees";
import groups from "@/api/groups";
import institution from "@/api/institution";
import meals from "@/api/meals";
import mealDishes from "@/api/mealDishes";
import meetingAgendaPoints from "@/api/meetingAgendaPoints";
import meetings from "@/api/meetings";
import employeesTitles from "@/api/employeesTitles";
import externalContent from "@/api/externalContent";
import news from "@/api/news";
import pictograms from "@/api/pictograms";
import planner from "@/api/planner";
import profile from "@/api/profile";
import relativeProfile from "@/api/relativeProfile";
import repeat from "@/api/repeat";
import resource from "@/api/resource";
import user from "@/api/user";
import coreNews from "@/api/coreNews";
import workSchedule from "@/api/workSchedule";

export default {
  activities,
  authors,
  bookings,
  calendar,
  categories,
  departments,
  employees,
  groups,
  institution,
  meals,
  mealDishes,
  meetingAgendaPoints,
  meetings,
  employeesTitles,
  externalContent,
  news,
  pictograms,
  planner,
  profile,
  repeat,
  relativeProfile,
  resource,
  user,
  coreNews,
  workSchedule,
};
